import { useEffect, useState } from 'react'
import { atom, useRecoilState } from 'recoil'
import { getRequest, postRequest } from '/src/httpClient'

export const cartInventoryState = atom({
  key: 'cartInventoryState',
  default: false
})

export const useCartInventory = (cart_id) => {
  const [results, setResults] = useRecoilState(cartInventoryState)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!cart_id) return
    const controller = new AbortController();

    (async () => {
      setIsLoading(true)
      setResults(await getRequest(`/api/inventory/cart?id=${cart_id}`, controller))
      setIsLoading(false)
    })()

    return () => controller.abort()
  }, [cart_id])

  return { results, isLoading }
}

export const useCartInventoryAll = (product_variation_id, quantity) => {
  const [results, setResults] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const controller = new AbortController();

    (async () => {
      setIsLoading(true)
      setResults(
        await getRequest(
          `/api/inventory/all?p=${product_variation_id}&q=${quantity}`, 
          controller
        )
      )
      setIsLoading(false)
    })()

    return () => controller.abort()
  }, [])

  return { results, isLoading }
}